import React from 'react';
import { styled } from '@nykaa/ui-components';
const Wrapper = styled.p `
  color: ${({ theme, color }) => { var _a; return color || ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.primary); }};
  margin-bottom: ${({ theme }) => { var _a; return (_a = theme.spacing) === null || _a === void 0 ? void 0 : _a.spacing40; }};
  ${({ theme }) => { var _a; return (_a = theme.typography) === null || _a === void 0 ? void 0 : _a.subTitleSmall; }};
`;
function Offer({ message = '', color = '' }) {
    const isValidColor = (typeof color === 'string' && color.length);
    return (React.createElement(Wrapper, { color: isValidColor && color }, message));
}
export default Offer;
